import React, { useEffect, useState } from "react"
import { Space, Tooltip, Form, message } from "antd"

import TableCustom from "src/components/Table/CustomTable"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import CB1 from "src/components/Modal/CB1"
import PopupAction from "src/components/PopupAction"
import IconBase from "src/components/IconBase"
import WarehouseService from "src/services/WarehouseService"
import ViewDetailModal from "../Modal/ModalDetailExportWarehouse"
import FilterOut from "./FilterOut"
import RejectModal from "../Modal/RejectModal"
import dayjs from "dayjs"
import { filter, set } from "lodash"
import STORAGE, { getStorage } from "src/lib/storage"
import ModalCreateOrder from "../../../Order/Modal/ModalCreateOrder"

function ListDeliveryBill(props) {
  const [dataSource, setDataSource] = useState()
  const [dataSelected, setDataSelected] = useState([])
  const [isModalAction, setIsModalAction] = useState({})
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [form] = Form.useForm()
  const [summary, setSummary] = useState({})
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [openRejectModal, setOpenRejectModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [rejectReason, setRejectReason] = useState("")
  const [modalType, setModalType] = useState(null) // null | "create" | "edit"
  const [selectedId, setSelectedId] = useState(null)
  const [selectedRecord, setSelectedRecord] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")

  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""
  const fetchExportWarehouse = async (filter, keyword, status) => {
    props.setExcelKeyword(keyword)
    setLoading(true)
    try {
      const response = await WarehouseService.getExportWarehouse({
        page: pagination.current,
        per_page: pagination.pageSize,
        type: 1,
        status: status,
        filter: {
          ...filter,
        },
        keyword: keyword,
      })

      if (response?.success?.data) {
        const users = response?.success?.data || []
        const total = response?.success?.total || users.length
        const current = response.current_page
        const perPage = response.per_page
        const packages = response?.success?.data || []

        // Format lại dữ liệu nếu cần
        const dataFormat = {
          ...packages,
          // type_sim: typeSim.find(item => item.key === packages?.type_sim)?.value || "-",
        }

        setPagination({
          ...pagination,
          total,
        })
        setSummary({
          totalAccounts: total,
        })
        props.setFilter(filter)
        setDataSource(packages)
      } else {
        console.error("Failed to fetch packages:", response?.error)
      }
    } catch (error) {
      console.error("Fetch export warehouse error:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchExportWarehouse(filter, keyword, props.status)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    console.log(pagination)
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchExportWarehouse(filter, keyword, props.status)
      }
    }
  }, [filter, keyword, props.status, refresh])
  const handleBrowse = async record => {
    try {
      const response = await WarehouseService.updateStatusBrowse(record.ID)
      if (response?.message?.includes("thành công")) {
        message.success("Duyệt phiếu xuất kho thành công")
        fetchExportWarehouse(filter, keyword, props.status)
      } else {
        message.error("Duyệt phiếu xuất kho thất bại")
      }
    } catch (error) {
      console.error("Lỗi khi duyệt phiếu xuất kho:", error)

      const errorMessage =
        error?.response?.data?.message || "Đã xảy ra lỗi khi duyệt gói cước."
      message.error(errorMessage)
    }
  }
  const handleReject = record => {
    setSelectedRecord(record.ID) // Lưu chỉ ID của record
    setOpenRejectModal(true) // Mở modal từ chối
  }

  const handleRefuse = async record => {
    try {
      const response = await WarehouseService.updateStatusRefuse(
        selectedRecord,
        {
          note: rejectReason,
        },
      )
      if (response?.message?.includes("thành công")) {
        message.success("Từ chối phiếu xuất kho thành công")
        setOpenRejectModal(false)
        fetchExportWarehouse(filter, keyword, props.status)
      } else {
        message.error("Từ chối phiếu xuất kho")
      }
    } catch (error) {
      console.error("Lỗi khi từ chối phiếu xuất kho:", error)
      message.error("Đã xảy ra lỗi khi từ chối phiếu xuất kho.")
    }
  }
  // useEffect(() => {
  //     // Effect logic here if needed
  // }, [pagination.current, pagination.pageSize]);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setDataSelected(selectedRows)
    },
  }

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }
  const handleViewDetail = async record => {
    setSelectedId(record)
    setModalType("view")
  }
  const handleUpdate = async record => {
    setSelectedId(record)
    setModalType("edit")
  }
  // Cột phiếu xuất kho
  const column = [
    {
      title: "Mã đơn hàng",
      dataIndex: "export_code",
      align: "center",
    },
    {
      title: "Tên khách hàng",
      dataIndex: "customer",
      align: "center",
      key: "customer",
      render: customer => customer?.fullname || "",
    },
    // {
    //   title: "Loại SIM",
    //   dataIndex: "sim_quantity",
    //   key: "sim_quantity",
    // },
    {
      title: "Số lượng SIM",
      dataIndex: "sim_quantity",
      align: "center",
      key: "sim_quantity",
    },

    // {
    //   title: "Đơn giá SIM",
    //   dataIndex: "sim_unit_price",
    //   key: "sim_unit_price",
    //   render: value => (value ? new Intl.NumberFormat().format(value) : "0"),
    // },
    {
      title: "Dung lượng data",
      dataIndex: "data_quantity",
      align: "center",
      key: "data_quantity",
    },
    // {
    //   title: "Đơn giá data",
    //   dataIndex: "data_unit_price",
    //   key: "data_unit_price",
    //   render: value => (value ? new Intl.NumberFormat().format(value) : "0"),
    // },
    {
      title: "Tổng tiền",
      dataIndex: "total_amount",
      key: "total_amount",
      render: value => `${new Intl.NumberFormat().format(value)}`,
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Tổng tiền sau chiết khấu",
      dataIndex: "total_discount",
      key: "total_discount",
      render: value => `${new Intl.NumberFormat().format(value)}`,
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },

    {
      title: "Người tạo",
      dataIndex: "createby",
      align: "center",
      key: "createby",
      render: createby => createby?.fullname || "",
    },
    {
      title: "Ngày tạo",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
    },
    {
      title: "Người duyệt",
      dataIndex: "approved_export_by",
      align: "center",
      key: "approved_export_by",
      render: approvedby => approvedby?.fullname || "",
    },
    {
      title: "Ngày duyệt",
      dataIndex: "approved_export_at",
      align: "center",
      key: "approved_export_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      key: "status",
      fixed: "right",
      render: text => {
        switch (text) {
          // case "1":
          //   return (
          //     <span style={{ color: "orange", fontWeight: "bold" }}>
          //       Chờ duyệt
          //     </span>
          //   )
          // case "3":
          //   return (
          //     <span style={{ color: "green", fontWeight: "bold" }}>
          //       Đã duyệt
          //     </span>
          //   )
          // case "6":
          //   return (
          //     <span style={{ color: "red", fontWeight: "bold" }}>Từ chối</span>
          //   )
          case "3":
            return (
              <span style={{ color: "#0288d1", fontWeight: "bold" }}>
                Hoàn thành mua
              </span>
            )
          case "4":
            return (
              <span style={{ color: "#6a1b9a", fontWeight: "bold" }}>
                Đã xuất kho
              </span>
            )
          case "2":
            return (
              <span style={{ color: "#1976d2", fontWeight: "bold" }}>
                Đã tiếp nhận
              </span>
            )
          case "6":
            return (
              <span style={{ color: "red", fontWeight: "bold" }}>Đã hủy</span>
            )
          default:
            return "Không xác định"
        }
      },
    },
    {
      title: <Tooltip title={"Hành động"}>_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => {
        const isPending = record.status === "1"
        const isPurchase = record.status === "3"
        const isReceived = record.status === "2"
        return (
          <PopupAction>
            {permissions.includes("warehouse.export.detail") ? (
              <div onClick={() => handleViewDetail(record)}>
                <IconBase name="eye" />
                <span>Xem chi tiết</span>
              </div>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("warehouse.export") && isPending ? (
              <div onClick={() => handleUpdate(record)}>
                <IconBase name="edit" />
                <span>Sửa</span>
              </div>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("warehouse.export.browse") && isPurchase ? (
              <div onClick={() => handleBrowse(record)}>
                <IconBase name="approval" />
                <span>Duyệt xuất kho</span>
              </div>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("warehouse.export.refuse") && isReceived ? (
              <div onClick={() => handleReject(record)}>
                <IconBase name="cancelApproval" />
                <span>Hủy xuất kho</span>
              </div>
            ) : (
              <React.Fragment />
            )}
          </PopupAction>
        )
      },
    },
  ]

  return (
    <div>
      {!!dataSelected.length && (
        <ButtonCircle
          style={{ marginRight: "10px", marginBottom: "10px" }}
          title="Xóa hàng đã chọn"
          iconName="delete-outline"
          onClick={() =>
            CB1({
              title: `Bạn có chắc chắn muốn xoá <strong>${dataSelected.length}</strong> bản ghi không?`,
              icon: "trashRed",
              okText: "Đồng ý",
              onOk: async close => {
                // Logic to delete selected rows
                close()
              },
            })
          }
        />
      )}
      <FilterOut setFilter={setFilter} setKeyword={setKeyword} />
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số:{summary.totalAccounts}</strong>
        </div>
      </div>

      <TableCustom
        isPrimary
        columns={column}
        loading={loading}
        dataSource={dataSource}
        showPagination
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
      />

      {/* {modalType === "view" && (
        <ViewDetailModal
          open={true}
          onCancel={() => setModalType(null)}
          form={form}
          recordId={selectedId}
        />
      )} */}
      {/* {openModalDetail && (
              <ModalCreateOrder
                open={openModalDetail}
                onCancel={() => setOpenModalDetail(false)}
                onOk={() => {
                  setOpenModalDetail(false)
                }}
                // data={dataSource.find(item => item.index === isModalAction.customerId)}
                editingRecord={editingRecord}
                isEditMode={true}
                refresh={setRefresh}
                onlyView={true}
              />
            )} */}
      {modalType === "view" && (
        <ModalCreateOrder
          open={true}
          onCancel={() => setModalType(null)}
          editingRecord={selectedId}
          isEditMode={true}
          onlyView={true}
        />
      )}
      {modalType === "edit" && (
        <ModalCreateOrder
          open={true}
          onCancel={() => setModalType(null)}
          editingRecord={selectedId}
          isEditMode={true}
          refresh={setRefresh}
          exportEdit={true}
        />
      )}

      <RejectModal
        open={openRejectModal}
        onCancel={() => setOpenRejectModal(false)}
        onConfirm={handleRefuse}
        setRejectReason={setRejectReason}
      />
    </div>
  )
}

export default ListDeliveryBill
